import { frontendURL } from '../../../../helper/URLHelper';

const pipelines = accountId => ({
  parentNav: 'board',
  routes: [
    'pipeline',
    'pipeline_boards',
    'pipeline_custom_view',
  ],
  menuItems: [
    {
      // icon: 'pipeline',
      // key: 'pipeline',
      // label: 'BOARDS',
      // toState: frontendURL(`accounts/${accountId}/pipelines`),
      // toStateName: 'pipeline',
    },
  ],
});

export default pipelines;
